module.exports = __webpack_public_path__ + "static/img/2设计师3.426397b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/2设计师3.png
// module id = Zu6g
// module chunks = 1